import * as React from 'react';
import { connect } from "react-redux";
import { KenticoFormContainer } from '../../containers/KenticoFormContainer';
import { LidZoekenHelpers } from '../pages/helpers/LidZoekenHelpers';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import * as UrlHelper from '../../../core/utils/url-helpers';
import { IFormConfig } from 'reactcomponents/interfaces/FormConfig';
import { IFormDefinition } from 'reactcomponents/interfaces/FormDefinition';

export interface MijnFNVLidZoekenLoadMoreProps {
  editMode: boolean;
  formConfig: IFormConfig;
  formName: string;
  pageType: string;
  formDefinitions: IFormDefinition;
  additionalCssClass: string;

  forms: any;
  lidZoeken: any;
}

const mapStateToProps = (state : any) => {
  return {
    lidZoeken: state.lidZoeken,
    forms: state.forms,
  };
};

export class MijnFNVLidZoekenLoadMoreContained extends React.Component<MijnFNVLidZoekenLoadMoreProps> {
  render() {
    const formConfig = { ...this.props.formConfig };

    const queryParams: UrlHelper.IQueryParam[] = [{ key: 'pageNumber', value: this.props.lidZoeken.pageNumber + 1 }];
    
    formConfig.postUrl = formConfig.postUrl.replace('{ZoekenOp}', this.props.lidZoeken.zoekenOp);
    formConfig.postUrl = formConfig.postUrl.replace('{*ZoekenOp}', this.props.lidZoeken.searchValue);
    formConfig.postUrl = UrlHelper.addQueryParameters(formConfig.postUrl, queryParams);
    

    formConfig.postPutMethod = 'post';
    formConfig.handlers = [...LidZoekenHelpers.getProcesses(formConfig)];
    
    return <>
      {this.props.lidZoeken !== undefined && this.props.lidZoeken.isSearchInitialised && 
        this.props.lidZoeken.results.length >= 1 && this.props.lidZoeken.hasMoreResults &&
        <KenticoFormContainer
          editMode={this.props.editMode}
          formConfig={formConfig}
          formDefinitions={this.props.formDefinitions}
          additionalCssClass={this.props.additionalCssClass}
          withLinkToFormPage={false}
          formName={this.props.formName}
          pageType={this.props.pageType}
        />}
    </>;
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}

export const MijnFNVLidZoekenLoadMore = connect(mapStateToProps)(MijnFNVLidZoekenLoadMoreContained);
